import {useState, useEffect, useCallback} from "react";

export default function useScanner(inputValue) {
    const [isTyping, setIsTyping] = useState(false);
    const [time, setTime] = useState(0);
    const [intervalId, setIntervalId] = useState();
    const [inputType, setInputType] = useState('');

    const isScanner = !(inputType === 'insertFromPaste' || inputType === 'insertReplacementText' || inputType === 'deleteContentBackward' || time > 1);

    const handleStopTime = useCallback(() => {
        clearInterval(intervalId);
        setIntervalId(undefined);
        setIsTyping(false);
        setTime(0);
    }, [intervalId])

    function handleChange(e, handler) {
        e.nativeEvent?.inputType && setInputType(e.nativeEvent.inputType);
        handler()
    }

    useEffect(() => {
        if (inputValue) {
            setIsTyping(true)
        }
    }, [inputValue])

    useEffect(() => {
        if (isTyping) {
            const intervalId = setInterval(() => {
                setTime(prevState => prevState + 1);
            }, 1000);
            setIntervalId(intervalId);
        }
    }, [isTyping])

    useEffect(() => {
        if (!inputValue && intervalId) {
            handleStopTime()
        }
    }, [inputValue, intervalId, handleStopTime])

    return {
        handleStopTime,
        handleChange,
        isScanner
    }
}